module.exports = __webpack_public_path__ + "img/1-creative-belt-IMG_2583.5ab363f2.png";